import {User} from "./User";
import {WorkingHours} from "./WorkingHours";
import {MyLocation} from "./Location";
import {Tag} from "./Tag";

export class Restaurant {

    private _id: number;
    private _email: string;
    private _phone_number: string;
    private _name: string;
    private _owner: User;
    private _location: MyLocation;
    private _distance: number;
    private _working_hours: WorkingHours;
    private _working_hours_list: WorkingHours[];
    private _rating: number;
    private _logo_url: string;
    private _banner_url: string;
    private _is_approved: boolean;
    private _tags: Tag[];

    constructor() {
        this._id = 0;
        this._email = "";
        this._phone_number = "";
        this._name = "";
        this._owner = new User();
        this._location = new MyLocation();
        this._distance = 0;
        this._working_hours = new WorkingHours();
        this._working_hours_list = [];
        this._rating = 0;
        this._banner_url = "";
        this._logo_url = "";
        this._is_approved = false;
        this._tags = [];
    }

    get id(): number { return this._id; }
    set id(value: number) { this._id = value; }

    get email(): string { return this._email; }
    set email(value: string) { this._email = value; }

    get phone_number(): string { return this._phone_number; }
    set phone_number(value: string) { this._phone_number = value; }

    get name(): string { return this._name; }
    set name(value: string) { this._name = value; }

    get owner(): User { return this._owner; }
    set owner(value: User) { this._owner = value; }

    get location(): MyLocation { return this._location; }
    set location(value: MyLocation) { this._location = value; }

    get distance(): number { return this._distance; }
    set distance(value: number) { this._distance = value; }

    get working_hours(): WorkingHours { return this._working_hours; }
    set working_hours(value: WorkingHours) { this._working_hours = value; }

    get working_hours_list(): WorkingHours[] { return this._working_hours_list; }
    set working_hours_list(value: WorkingHours[]) { this._working_hours_list = value; }

    get rating(): number { return this._rating; }
    set rating(value: number) { this._rating = value; }

    get logo_url(): string { return this._logo_url; }
    set logo_url(value: string) { this._logo_url = value; }

    get banner_url(): string { return this._banner_url; }
    set banner_url(value: string) { this._banner_url = value; }

    get is_approved(): boolean { return this._is_approved; }
    set is_approved(value: boolean) { this._is_approved = value; }

    get tags(): Tag[] { return this._tags; }
    set tags(value: Tag[]) { this._tags = value; }
}